import { render } from "./CouponCardMobile.vue?vue&type=template&id=b1816eca&scoped=true"
import script from "./CouponCardMobile.vue?vue&type=script&lang=js"
export * from "./CouponCardMobile.vue?vue&type=script&lang=js"

import "./CouponCardMobile.vue?vue&type=style&index=0&id=b1816eca&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1816eca"]])

export default __exports__